/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eta_Window_Card_TitleInputs */

const en_eta_window_card_title = /** @type {(inputs: Eta_Window_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETA window`)
};

const ja_eta_window_card_title = /** @type {(inputs: Eta_Window_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`到着予定時間帯`)
};

const fr_eta_window_card_title = /** @type {(inputs: Eta_Window_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créneau d'arrivée prévue`)
};

const de_eta_window_card_title = /** @type {(inputs: Eta_Window_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETA-Zeitfenster`)
};

/**
* | output |
* | --- |
* | "ETA window" |
*
* @param {Eta_Window_Card_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const eta_window_card_title = /** @type {((inputs?: Eta_Window_Card_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eta_Window_Card_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eta_window_card_title(inputs)
	if (locale === "ja") return ja_eta_window_card_title(inputs)
	if (locale === "fr") return fr_eta_window_card_title(inputs)
	return de_eta_window_card_title(inputs)
});